import Vue from 'vue'
import App from './App.vue'

//引入路由操作
import router from './router/index.js' //引入路由配置文件

//3d echarts引入
import highcharts from 'highcharts'
import highcharts3d from 'highcharts/highcharts-3d'
highcharts3d(highcharts)

//高德地图配置
window._AMapSecurityConfig = {
	serviceHost: 'http://www.test.com//_AMapService',
	securityJsCode: '0ead6099f5e472bd7476f1d78627ec2f',
};

//request请求配置
import request from "./utils/request.js"
Vue.prototype.request = request

//导入ElementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
//使用ElementUI
Vue.use(ElementUI);

Vue.config.productionTip = false
new Vue({
	router,
  render: h => h(App),
}).$mount('#app')
